import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('aspectosfisiograficos');

export const check = () => useBasicAuth.checkToken();

export const findAspectosFisiograficosById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllAspectosFisiograficos = () => 
  axios.get(urlAPI + "/findAll" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllAspectosFisiograficosByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllAspectosFisiograficosByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const addAspectosFisiograficos = (obj) => 
  axios.post(urlAPI + "/addAspectosFisiograficos", JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateAspectosFisiograficos = (obj) => 
  axios.put(urlAPI + "/updateAspectosFisiograficos/" + obj.aspectosFisiograficos.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteAspectosFisiograficos = (id) => 
  axios.delete(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



  //CLIMA_CIDADE
export const findAllByAspectosFisiograficosCidade_aspectosFisiograficos = (aspectosFisiograficos) => 
axios.post(urlAPI + "/aspectosFisiograficoscidade/aspectosFisiograficos", JSON.stringify(aspectosFisiograficos), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByAspectosFisiograficosCidade_cidade = (cidade) => 
axios.post(urlAPI + "/aspectosFisiograficoscidade/cidade", JSON.stringify(cidade), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByAspectosFisiograficosCidade = (aspectosFisiograficos, cidade) => {
let requestObj = {
  aspectosFisiograficos: aspectosFisiograficos,
  cidade: cidade
}
axios.post(urlAPI + "/aspectosFisiograficoscidade", JSON.stringify(requestObj), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});
}


//CLIMA_ESTADO
export const findAllByAspectosFisiograficosEstado_aspectosFisiograficos = (aspectosFisiograficos) => 
axios.post(urlAPI + "/aspectosFisiograficosestado/aspectosFisiograficos", JSON.stringify(aspectosFisiograficos), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByAspectosFisiograficosEstado_estado = (estado) => 
axios.post(urlAPI + "/aspectosFisiograficosestado/estado", JSON.stringify(estado), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByAspectosFisiograficosEstado = (aspectosFisiograficos, estado) => {
let requestObj = {
  aspectosFisiograficos: aspectosFisiograficos,
  estado: estado
}
axios.post(urlAPI + "/aspectosFisiograficosestado", JSON.stringify(requestObj), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});
}